import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Configurator from './components/Configurator';
import Login from './components/Login';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Configurator />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;